import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/tm.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { ImCalendar } from "react-icons/im";
import {CgCodeSlash} from "react-icons/cg";
import {ImWhatsapp} from "react-icons/im";
import {CgPhone} from "react-icons/cg";
import Meet from "./Meeting";
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/about"
                onClick={() => updateExpanded(false)}
              >
                <CgProfile style={{ marginBottom: "2px" }} /> About
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/project"
                onClick={() => updateExpanded(false)}
              >
                <CgCodeSlash
                  style={{ marginBottom: "2px" }}
                />{" "}
                Projects
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/resume"
                onClick={() => updateExpanded(false)}
              >
                <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className="fork-btn">
             
                <Button
                href="https://calendly.com/d/4sn-w3w-xq7/initial-consultation-call?hide_gdpr_banner=1&background_color=4d2477&text_color=ffffff&primary_color=2e1b4e"
                target="_blank"
                className="fork-btn-inner"
              >
                <ImCalendar style={{ marginBottom: "2px" }} /> Meeting
              </Button>
              {/* <!-- Calendly inline widget begin -->
<div class="calendly-inline-widget" data-url="https://calendly.com/d/4sn-w3w-xq7/initial-consultation-call?hide_gdpr_banner=1&background_color=4d2477&text_color=ffffff&primary_color=2e1b4e" style="min-width:320px;height:700px;"></div>
<script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
<!-- Calendly inline widget end -->             */}
            </Nav.Item>

            <Nav.Item className="fork-btn">
              <Button
                href="https://wa.link/fw7yll"
                target="_blank"
                className="fork-btn-inner"
                onClick={<Meet/>}
              >
                <CgPhone style={{ fontSize: "1.2em" }} />{" "} {" "}
                <ImWhatsapp style={{ fontSize: "1.1em" }} />
                {/* <CgGitFork style={{ fontSize: "1.2em" }} />{" "}
                <AiFillStar style={{ fontSize: "1.1em" }} /> */}
                {/* CgPhone CgSignal ImWhatsapp CgGitFork AiFillStar*/}
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
